import React from "react";

export const Footer = () => (
    <div>
        
    </div>
);